export interface SplitChar {
  value: string
  key: string
}

export interface SplitWord {
  value: string
  key: string
  chars: SplitChar[]
}

export function splitIntoChars(text: string): SplitChar[] {
  return Array.from(text).map((value, index) => ({
    value,
    key: `${index}-${value}`,
  }))
}

export function splitIntoWords(text: string): SplitWord[] {
  return text
    .split(' ')
    .filter((word) => word.length > 0)
    .map((word, wordIndex) => ({
      value: word,
      key: `${wordIndex}-${word}`,
      chars: Array.from(word).map((value, charIndex) => ({
        value,
        key: `${wordIndex}-${charIndex}-${value}`,
      })),
    }))
}
